export default __webpack_public_path__ + "257c7e65635623b77d850d4d11c1705d.png";